import generateQuery from '@/libs/generate-query'
import HttpRequest from './HttpRequest'

class CategoriesProvider extends HttpRequest {
  findAll (config) {
    return this.get('/category', undefined, config)
  }

  /** Lean active categories for cascading selects (+ additional.version). */
  findAllOptions (config) {
    return this.get('/category/options', undefined, config)
  }

  getVersion (config) {
    return this.get('/category/version', undefined, config)
  }

  findOne (id) {
    return this.get(`/category/${id}`)
  }

  createGroup (payload) {
    return this.post('/category', payload)
  }

  updateGroup (id, payload) {
    return this.patch(`/category/${id}`, payload)
  }

  deleteGroup (id) {
    return this.delete(`/category/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/category/all/paginate?page=${page}&limit=${limit}${generateQuery(query)}`)
  }
}

export default CategoriesProvider
